export const headerComponentId = "UW2LLARmS3Oryu_9BT0IBQ"; //todo this is a bit rubbish
export const footerComponentId = "QR1NY2zlRK-luRZZkbfB1w";